import { render, staticRenderFns } from "./notification-send-component.vue?vue&type=template&id=a3c7cd00&scoped=true&lang=pug"
import script from "./notification-send-component.js?vue&type=script&lang=js&external"
export * from "./notification-send-component.js?vue&type=script&lang=js&external"
import style0 from "./notification-send-component.vue?vue&type=style&index=0&id=a3c7cd00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c7cd00",
  null
  
)

export default component.exports